/* eslint-disable no-restricted-globals */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import React, {
  useState, useRef, useMemo, useEffect,
} from 'react';
import ReactQuill from 'react-quill';
import DatePicker from 'react-datepicker';
import moment from 'moment/moment';
import { ToastContainer } from 'react-toastify';
import Input from '../../../components/forms/input';
import InputPrepend from '../../../components/forms/InputPrepend';
import InputPrepend2 from '../../../components/forms/InputPrepend2';
import ButtonAction from '../../../components/buttons/ButtonAction';
import Select2 from '../../../components/forms/Select2';
import ImageModal from '../../../components/modal/ImageModal';
import replaceBase64WithUploadedUrls from '../../../utils/replaceBase64WithUploadedUrls';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import ConfirmationModal from '../../../components/modal/ConfirmModal';
import saveIcon from '../../../assets/images/icons/SaveIcon.svg';
import 'react-datepicker/dist/react-datepicker.css';
import { getProgramDonationById, updateDonationById, AddStoryImage } from '../../../services/donation';
import { DonationSubType, DonationType } from '../../../utils/Constants';

const styleInactiveBreadcrumb = {
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '14px',
  color: 'rgba(79, 88, 103, 0.7)',
  textDecoration: 'none',
  fontFamily: 'BlueberrySans-Regular',
};
const styleActiveBreadcrumb = {
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '14px',
  color: 'rgba(79, 88, 103, 0.7)',
  textDecoration: 'none',
  fontFamily: 'BlueberrySans-Regular',
};

function EditProgramPatronage(props) {
  const { id } = useParams();
  const formikRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [quillValue, setQuillValue] = useState('');
  const quillRef = useRef();
  const optionsUlangi = [
    { value: 'WEEKLY', label: 'Setiap Minggu' },
    { value: 'DAILY', label: 'Setiap Hari' },
  ];
  const optionsStatus = [
    { value: true, label: 'Aktif' },
    { value: false, label: 'Tidak Aktif' },
  ];
  const optionsFundraiser = [
    { value: 'Dzikra', label: 'Dzikra' },
    { value: 'Inovasi 360', label: 'Inovasi 360' },
    { value: 'rumah_zakat', label: 'Rumah Zakat' },
    { value: 'DT Peduli', label: 'DT Peduli' },
    { value: 'zakat_sukses', label: 'Zakat Sukses' },
    { value: 'dompet_dhuafa', label: 'Dompet Dhuafa' },
    { value: 'mizan_amanah', label: 'Mizan Amanah' },
    { value: 'ydsf', label: 'Yayasan Dana Sosial Al Falah' },
    { value: 'bmh', label: 'Baitul Maal Hidayatullah' },
    { value: 'mitra_yatim', label: 'Mitra Yatim' },
  ];
  const [programName, setProgramName] = useState('');
  const [media, setMedia] = useState();
  const [defaultMedia, setDefaultMedia] = useState(null);
  const [defaultThumbnail, setDefaultThumbnail] = useState(null);
  const [mediaName, setMediaName] = useState('Upload File Poster');
  const [donationTarget, setDonationTarget] = useState('');
  const [donationTargetDisplay, setDonationTargetDisplay] = useState('');
  const [duration, setDuration] = useState('');
  const [status, setStatus] = useState(null);
  const [fundraiser, setFundraiser] = useState('');
  const [thumbnail, setThumbnail] = useState();
  const [nameThumbnail, setNameThumbnail] = useState('Upload File Gambar Cerita Program');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [defaultStartDate, setDefaultStartDate] = useState(null);
  const [defaultEndDate, setDefaultEndDate] = useState(null);
  const [stopTimeDisplay, setStopTimeDisplay] = useState('');
  const [repeat, setRepeat] = useState('');
  const [storyDescription, setStoryDescription] = useState('');
  const [swich, setSwich] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [isInvalidClassName, setIsInvalidClassName] = useState('');
  const [isDblock, setIsDblock] = useState('d-none');
  const [isEditedDonation, setIsEditedDonation] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalCloseConfirmation, setShowModalCloseConfirmation] = useState(false);
  const getDate = moment().format('YYYY-MM-DD');
  const [showImageMedia, setShowImageMedia] = useState(false);
  const [showThumbnail, setShowThumbnail] = useState(false);
  const [editMedia, setEditMedia] = useState(false);
  const [editThumbnail, setEditThumbnail] = useState(false);
  const [type, setType] = useState(null);
  const [subType, setSubType] = useState(null);

  const initialValues = {
    programName: programName ?? '',
    media: media ?? '',
    donationTarget: donationTarget ?? '',
    duration: duration ?? '',
    status: status === null ? false : status,
    fundraiser: fundraiser ?? '',
    thumbnail: thumbnail ?? null,
    startTime: startTime ?? null,
    endTime: endTime ?? null,
    repeat: repeat ?? '',
    type: type ?? null,
    subType: subType ?? null,
  };

  const validation = Yup.object().shape({
    programName: Yup.string()
      .required('Nama Donasi Wajib Diisi')
      .max(100, 'Nama Donasi Terlalu Panjang')
      .nullable(),
    donationTarget: Yup.string()
      .required('Target Donasi Wajib Diisi')
      .nullable(),
    status: Yup.boolean().required('Status Wajib Diisi').nullable(),
    fundraiser: Yup.string().required('Jenis Penggalang Dana Wajib Diisi').nullable(),
    media: Yup.mixed()
      .required('Media Wajib Diisi')
      .test(
        'fileSize',
        'Gambar Maksimal 1MB',
        (value) => {
          if (!value) return true;
          if (typeof value === 'string') return true;
          return value.size <= 1000000;
        },
      )
      .test(
        'fileFormat',
        'Tipe file tidak didukung',
        (value) => {
          if (!value) return true;
          if (typeof value === 'string') return true;
          return ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'].includes(value.type);
        },
      ),
    thumbnail: Yup.mixed()
      .nullable()
      .test(
        'fileSize',
        'Gambar Maksimal 1MB',
        (value) => {
          if (!value) return true;
          if (typeof value === 'string') return true;
          return value.size <= 1000000;
        },
      )
      .test(
        'fileFormat',
        'Tipe file tidak didukung',
        (value) => {
          if (!value) return true;
          if (typeof value === 'string') return true;
          return ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'].includes(value.type);
        },
      ),
    type: Yup.number().required('Tipe Donasi Wajib Diisi'),
    subType: Yup.number()
      .nullable()
      .when('type', {
        is: 3,
        then: (d) => d.required('Sub Tipe Donasi misi wajib diisi'),
        otherwise: (d) => d.notRequired(),
      }),
  });

  const imageHandler = () => {
    const editor = quillRef.current.getEditor();
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (file.size > 1 * 1024 * 1024) {
        toastError('Ukuran gambar maksimal 1MB!');
        return;
      }

      try {
        const formData = new FormData();
        formData.append('storyDescriptionImage', file);
        const response = await AddStoryImage(formData);
        const result = await response.text();
        const link = result;
        editor.insertEmbed(editor.getSelection(), 'image', link);
      } catch (err) {
        console.log('upload err:', err);
      }
    };
  };

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ script: 'sub' }, { script: 'super' }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
        ['link', 'image'],
        ['clean'],
      ],
      handlers: {
        image: imageHandler,
      },
    },
  }), []);

  const handleSwich = (e) => {
    setSwich(e.target.checked);
  };

  const handleClose = () => setShowModal(false);
  const handleCloseModalConfirmation = () => setShowModalCloseConfirmation(false);
  const checkForm = (oldvalues, currentValues) => {
    if (id) {
      if (oldvalues.programName !== currentValues.programName
      || oldvalues.media !== currentValues.media
      || oldvalues.donationTarget !== currentValues.donationTarget
      || oldvalues.status !== currentValues.status
      || oldvalues.fundraiser !== currentValues.fundraiser
      || oldvalues.thumbnail !== currentValues.thumbnail
      || oldvalues.startTime !== currentValues.startTime
      || oldvalues.endTime !== currentValues.endTime
      || oldvalues.repeat !== currentValues.repeat
      || oldvalues.type !== currentValues.type
      || oldvalues.subType !== currentValues.subType) {
        setIsEditedDonation(true);
      } else {
        setIsEditedDonation(false);
      }
    }
  };
  const isFormEditedProgress = () => {
    if (id && isEditedDonation) {
      setShowModalCloseConfirmation(true);
    } else {
      navigate('/patronage/program');
    }
  };
  const handleShowMediaInput = (event) => {
    setShowImageMedia(true);
  };

  const handleCloseMediaInput = () => {
    setShowImageMedia(false);
  };
  const handleShowThumbnailInput = () => {
    setShowThumbnail(true);
  };

  const handleCloseThumbnailInput = () => {
    setShowThumbnail(false);
  };
  useEffect(() => {
    const handleProgramDonation = async () => {
      const response = await getProgramDonationById(id);
      setDefaultMedia(response.media);
      setDefaultThumbnail(response.storyThumbnail);
      setProgramName(response.programName);
      setDonationTarget(response.donationTarget);
      setMedia(response.media);
      if (response.media !== null) {
        const mediaFilename = response.media.split('/').pop();
        setMediaName(mediaFilename);
      }
      setStatus(response.status);
      setFundraiser(response.fundraiser);
      setStartTime(response.startTime);
      setEndTime(response.endTime);
      setRepeat(response.repeat);
      setStoryDescription(response.storyDescription);
      setThumbnail(response.storyThumbnail);
      if (response.storyThumbnail !== null) {
        const storyThumbnailFilename = response.storyThumbnail.split('/').pop();
        setNameThumbnail(storyThumbnailFilename);
      }
      setDefaultStartDate(moment(response.startDate).format('yyyy/MM/DD'));
      setDefaultEndDate(moment(response.endDate).format('yyyy/MM/DD'));
      const moneyFormatter = new Intl.NumberFormat();
      const donationFormat = moneyFormatter.format(response.donationTarget);
      setDonationTargetDisplay(donationFormat.replaceAll(',', '.'));
      setDonationTarget(response.donationTarget);
      const editor = quillRef.current.getEditor();
      editor.clipboard.dangerouslyPasteHTML(response.storyDescription);
      const start = moment(response.startDate, 'YYYY-MM-DD');
      const end = moment(response.endDate, 'YYYY-MM-DD');
      const day = moment.duration(end.diff(start)).asDays();
      setDuration(day);
      setType(response.type);
      if (response.subtype) {
        setSubType(response.subtype);
      }
    };
    if (id) {
      handleProgramDonation();
    }
  }, []);

  return (
    <div className="content-container-side">
      <ImageModal show={showImageMedia} handleClose={handleCloseMediaInput} srcMedia={defaultMedia} />
      <ImageModal show={showThumbnail} handleClose={handleCloseThumbnailInput} srcMedia={defaultThumbnail} />
      <div className="d-flex">
        <p className="content-title">
          Patronage
        </p>
      </div>
      <div className="mb-4">
        <Breadcrumbs aria-label="breadcrumb" separator="">
          <Link
            color="inherit"
            to="/patronage/program"
            onClick={() => {
            }}
            style={styleActiveBreadcrumb}
          >
            Daftar Program
          </Link>
          <Typography style={styleInactiveBreadcrumb}>
            Edit Program
          </Typography>
        </Breadcrumbs>
      </div>
      <Card className="card-datatable">
        <div className="d-flex flex-wrap align-items-center">
          <span
            className="material-icons clickable"
            style={{ marginTop: '-12px' }}
            onClick={() => {
              isFormEditedProgress();
            }}
            onKeyPress={() => navigate('/patronage/program')}
            role="button"
            tabIndex={0}
          >
            arrow_back
          </span>
          <p className="card-datatable-title ms-3">
            Edit Program
          </p>
        </div>
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={validation}
          enableReinitialize
          onSubmit={(values, errors, touched) => {
            setShowModal(true);
          }}
        >
          {(props) => (
            <Form>
              {checkForm(initialValues, props.values)}
              <ConfirmationModal
                show={showModal}
                message="Apakah Anda yakin data yang dimasukkan sudah sesuai?"
                onHide={handleClose}
                confirmTitle="Ya, lanjutkan"
                cancelTitle="Periksa Kembali"
                toggle={handleClose}
                inlineIcon={saveIcon}
                confirm={async () => {
                  setShowModal(false);
                  const formData = new FormData();
                  formData.append('programName', props.values.programName);
                  formData.append('duration', props.values.duration);
                  formData.append('status', props.values.status);
                  formData.append('fundraiser', props.values.fundraiser);
                  formData.append('donationTarget', props.values.donationTarget);
                  formData.append('thumbnail', props.values.thumbnail);
                  formData.append('startTime', props.values.startTime);
                  formData.append('endTime', props.values.endTime);
                  formData.append('repeat', props.values.repeat);
                  formData.append('startDate', startDate === null ? defaultStartDate : moment(startDate).format('yyyy/MM/DD'));
                  formData.append('endDate', endDate === null ? defaultEndDate : moment(endDate).format('yyyy/MM/DD'));
                  formData.append('media', props.values.media);
                  formData.append('donationTarget', props.values.donationTarget);

                  const cleanedDescription = await replaceBase64WithUploadedUrls(quillValue);
                  formData.append('storyDescription', cleanedDescription);

                  formData.append('type', props.values.type);
                  if (props.values.subType) formData.append('subType', props.values.subType);

                  updateDonationById(id, formData).then((response) => {
                    if (response.status === 200) {
                      localStorage.setItem('isEditedDonation', true);
                      setTimeout(() => {
                        navigate('/patronage/program');
                      }, 100);
                    }
                  });
                }}
              />
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <Input
                    title="Nama Donasi"
                    name="programName"
                    type="text"
                    errors={props?.errors}
                    touched={props?.touched}
                    {...props?.getFieldProps('programName')}
                  />
                </div>
                <div className="col-lg-6 col-md-12">
                  <Input
                    title="Poster"
                    name="media"
                    isShowMedia
                    filename={mediaName}
                    onShowMedia={handleShowMediaInput}
                    type="file"
                    errors={props?.errors}
                    touched={props?.touched}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      props?.setFieldValue('media', file);
                      setMediaName(file.name);
                      setEditMedia(true);
                    }}
                    accept="image/png, image/jpeg"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="form-label">Tanggal</label>
                    <DatePicker
                      selectsRange
                      className={`form-input form-control placeholder-black ${isInvalidClassName}`}
                      startDate={startDate}
                      placeholderText={defaultStartDate ? `${defaultStartDate} - ${defaultEndDate}` : ''}
                      endDate={endDate}
                      dateFormat="dd/MM/yyyy"
                      onChange={(update) => {
                        setDateRange(update);
                        const start = moment(update[0], 'YYYY-MM-DD');
                        const end = moment(update[1], 'YYYY-MM-DD');
                        const day = moment.duration(end.diff(start)).asDays();
                        setDuration(day);
                      }}
                    />
                    <div className={`invalid-feedback d-block ${isDblock}`}>
                      <p className="ms-1">Field Tanggal Harus Diisi</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 duration">
                  <InputPrepend
                    label="Durasi"
                    name="duration"
                    title="Hari"
                    type="number"
                    mb="0"
                    value={duration}
                    disabled
                    {...props?.getFieldProps('duration')}
                    width="20%"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <Select2
                    title="Penggalang Dana"
                    key={fundraiser}
                    defaultValue={optionsFundraiser.find(
                      ({ value }) => value === fundraiser,
                    )}
                    name="fundraiser"
                    placeholder="Pilih Data Status"
                    options={optionsFundraiser}
                    onChangeEvent={(selectedOption) => {
                      props.setFieldValue('fundraiser', selectedOption.value);
                    }}
                    errors={props?.errors}
                    touched={props?.touched}
                    {...props?.getFieldProps('fundraiser')}
                  />
                </div>
                <div className="col-lg-6 col-md-12 donation-goals">
                  <InputPrepend2
                    label="Target Donasi"
                    title="Rp"
                    name="donationTarget"
                    type="number/text"
                    value={donationTargetDisplay}
                    onChange={(e) => {
                      if (!isNaN(e.target.value.replaceAll('.', ''))) {
                        const moneyFormatter = new Intl.NumberFormat();
                        const donationFormat = moneyFormatter.format(e.target.value.replaceAll('.', ''));
                        setDonationTargetDisplay(donationFormat.replaceAll(',', '.'));
                        props.setFieldValue(
                          'donationTarget',
                          e.target.value.replaceAll('.', ''),
                          true,
                        );
                      }
                    }}
                    errors={props?.errors}
                    touched={props?.touched}
                    width="10%"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 d-none">
                  <Select2
                    title="Tipe Donasi"
                    key={type}
                    defaultValue={DonationType.find(
                      ({ value }) => value === type,
                    )}
                    name="type"
                    placeholder="Pilih Tipe Donasi"
                    options={DonationType}
                    onChangeEvent={(selectedOption) => {
                      props.setFieldValue('type', selectedOption.value);
                    }}
                    errors={props?.errors}
                    touched={props?.touched}
                    {...props?.getFieldProps('type')}
                  />
                </div>
                <div className="col-lg-6 col-md-12">
                  <Select2
                    title="Status"
                    key={status}
                    defaultValue={optionsStatus.find(
                      ({ value }) => value === status,
                    )}
                    name="status"
                    placeholder="Pilih Data Status"
                    options={optionsStatus}
                    onChangeEvent={(selectedOption) => {
                      props.setFieldValue('status', selectedOption.value);
                    }}
                    errors={props?.errors}
                    touched={props?.touched}
                    {...props?.getFieldProps('status')}
                  />
                </div>
              </div>
              {(subType || type === 3 || props?.values?.type === 3) && (
                <div className="row">
                  <div className="col-lg-6">
                    <Select2
                      title="Sub Tipe Donasi"
                      key={subType}
                      defaultValue={DonationSubType.find(
                        ({ value }) => value === subType,
                      )}
                      name="subType"
                      placeholder="Pilih Sub Tipe Donasi"
                      options={DonationSubType}
                      onChangeEvent={(selectedOption) => {
                        props.setFieldValue('subType', selectedOption.value);
                      }}
                      errors={props?.errors}
                      touched={props?.touched}
                      {...props?.getFieldProps('subType')}
                    />
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-lg-6 col-md-12 mt-3 card-datatable-title">
                  Cerita Program
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <Input
                    title="Gambar Cerita Program"
                    name="thumbnail"
                    isShowMedia
                    onShowMedia={handleShowThumbnailInput}
                    filename={nameThumbnail}
                    type="file"
                    errors={props?.errors}
                    touched={props?.touched}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      props.setFieldValue(
                        'thumbnail',
                        file,
                        true,
                      );
                      setNameThumbnail(file.name);
                      setEditThumbnail(true);
                      setDefaultThumbnail(file);
                    }}
                    accept="image/png, image/jpeg"
                  />
                </div>
                <div className="col-lg-12">
                  <div className="col-lg-12 col-md-12">
                    <div className="col-lg-6 col-md-12 description-label">
                      Deskripsi
                    </div>
                    <ReactQuill
                      title="Deskripsi"
                      theme="snow"
                      modules={modules}
                      onChange={setQuillValue}
                      ref={quillRef}
                    />
                  </div>
                </div>
              </div>
              <div className="switch-container mt-4 d-flex">
                <p className="card-datatable-title">Periode Program</p>
                <label className="switch ms-2 mt-1">
                  <input type="checkbox" onClick={handleSwich} />
                  <span className="slider round" />
                </label>
              </div>
              {swich ? (
                <div className="row">
                  <div className="col-lg-3 col-md-6">
                    <Input
                      title="Waktu Mulai"
                      name="startTime"
                      type="time"
                      errors={props?.errors}
                      touched={props?.touched}
                      {...props?.getFieldProps('startTime')}
                    />
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <Input
                      title="Waktu Selesai"
                      name="endTime"
                      type="time"
                      errors={props?.errors}
                      touched={props?.touched}
                      {...props?.getFieldProps('endTime')}
                    />
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <Select2
                      title="Ulangi"
                      key={repeat}
                      defaultValue={optionsUlangi.find(
                        ({ value }) => value === repeat,
                      )}
                      name="repeat"
                      placeholder="Pilih Data Ulangi"
                      options={optionsUlangi}
                      onChangeEvent={(selectedOption) => {
                        props.setFieldValue('repeat', selectedOption.value);
                      }}
                      errors={props?.errors}
                      touched={props?.touched}
                      {...props?.getFieldProps('repeat')}
                    />
                  </div>
                </div>
              ) : ' '}
              <div className="d-flex align-items-center mt-5">
                <div className="ms-auto">
                  <ButtonAction
                    cancelTitle="Batal"
                    confirmTitle="Simpan"
                    toggle={() => {
                      isFormEditedProgress();
                      // checkForm(formikRef.current.values);
                    }}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
        <ConfirmationModal
          show={modalCloseConfirmation}
          message="Apakah anda yakin ingin membatalkan proses edit program donasi?"
          onHide={handleClose}
          confirmTitle="Yakin"
          cancelTitle="Batal"
          toggle={handleCloseModalConfirmation}
          inlineIcon={saveIcon}
          confirm={() => {
            navigate('/patronage/program');
          }}
        />
        <ToastContainer />
      </Card>
    </div>
  );
}

export default EditProgramPatronage;
